import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const DataModelReportTools = ({
  code,
  downloadStart,
  isDownloading,
  report,
}) => {
  const intl = useIntl();
  return (
    <Dropdown.Item
      icon="download"
      className="primary"
      text={intl.formatMessage({ id: 'actions.download' })}
      as="a"
      onClick={() => downloadStart('downloads', code, report, true)}
      disabled={isDownloading}
    />
  );
};
export default DataModelReportTools;
